export const namespaces = {
  pages: {
    daolinv: "pages.daolinv",
    daolinvNdid: "pages.daolinvNdid",
    daolSecKyc: "pages.daolSecKyc",
    daolsecNdid: "pages.daolsecNdid",
    daolinvReviewSuitAndKyc : "pages.daolinvReviewSuitAndKyc",
    daol: "pages.daol"
  },
  common: "common",
};

export const languages = {
  th: "th",
  en: "en",
};